export const convert = {
  toString(val: any): string {
    return val + ""
  },

  toLong(val: any): number {
    return parseInt(val, 10)
  },
}

export default convert
